import { render, staticRenderFns } from "./TherapySignUp.vue?vue&type=template&id=3d4545d0"
import script from "./TherapySignUp.vue?vue&type=script&lang=js"
export * from "./TherapySignUp.vue?vue&type=script&lang=js"
import style0 from "./TherapySignUp.vue?vue&type=style&index=0&id=3d4545d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports